import { EuiThemeModifications } from '@elastic/eui';

export const theme: EuiThemeModifications = {
  colors: {
    LIGHT: { primary: '#155FA2', accent: '#B0153C' },
    DARK: { primary: '#155FA2', accent: '#B0153C' },
  },
};
